export const toastTypes = {
  warning: "warning",
  error: "error",
  success: "success",
}
